import Swiper from 'swiper/swiper-bundle';

export const menuItemSlider = () => {

	const swiperContentImage = new Swiper('.js-init-swiper', {
        slidesPerView: "auto",
        autoplay: false,
        loop: false,
        // spaceBetween: 32,
        // slidesPerView: 3,
        //effect: "fade",
         breakpoints: {
            390: {
              slidesPerView: 1.3,
              spaceBetween: 20,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 32,
            },
        },
        pagination: {
	        el: '.swiper-pagination',
	        type: 'bullets',
	        clickable: true
	    },
	    navigation: {
            nextEl: '.swiper-arrow--next',
            prevEl: '.swiper-arrow--prev',
        },
    });
}

menuItemSlider();